import { useTranslation, Trans } from "react-i18next";
import { Col, Row, Card, Table } from "react-bootstrap";
import HeaderFields from "../../HeaderFields";
import { Label } from "../../fields";
import { FaArrowAltCircleUp, FaArrowAltCircleDown, FaMinusCircle } from "react-icons/fa";
import { formatPercent } from "../../../../../utils/formatNumber";

const BetweenUnits = ({ uiState }) => {
  const { t } = useTranslation(["programs"]);
  return (
    <>
      <strong>{parseInt(uiState.units.increase.units) - 1}</strong>
      &nbsp;{t(($) => $.programs.templateForms["and"])}&nbsp;
      <strong> {parseInt(uiState.units.lower.units) + 1}</strong>
    </>
  );
};

const BetweenCR = ({ uiState }) => {
  const { t } = useTranslation(["programs"]);
  return (
    <>
      <strong>{formatPercent(uiState.ocr.lower.units - 1 + 0.0001)}</strong>
      &nbsp;{t(($) => $.programs.templateForms["and"])}&nbsp;
      <strong>{formatPercent(uiState.ocr.increase.units - 1 - 0.0001)}</strong>
    </>
  );
};

const MarginCRProfilingForm = ({ control, formState }) => {
  const { t } = useTranslation(["programs"]);
  const uiState = formState.defaultValues;

  return (
    <Row>
      {control && <HeaderFields control={control} formState={formState} />}
      <Col xs={12} className="mt-4">
        <Label>{t(($) => $.programs.templateForms["Margin Profiling Rules"])}</Label>
      </Col>
      <Col xs={12}>
        <Card className="p-4">
          <Card.Body>
            <div>
              <Trans
                i18nKey={($) =>
                  $.programs.templateForms["To increase the price of a product, the following conditions must be met:"]
                }
                components={{ strong: <strong /> }}
              />
            </div>
            <div className="py-2">
              <span className="">
                {t(($) => $.programs.templateForms["Increase Days: {days} days"], {
                  days: uiState.units.increase.days,
                })}{" "}
              </span>
              <span className="ps-3">
                {t(($) => $.programs.templateForms["Decrease Days: {days} days"], { days: uiState.units.lower.days })}
              </span>
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>{t(($) => $.programs.templateForms["Units / CR"])}</th>
                  <th className="text-center" style={{ color: "#000" }}>
                    <span className="fs-standard">
                      {t(($) => $.programs.templateForms["CR"])} <FaArrowAltCircleUp /> <br />
                      <strong>{formatPercent(uiState.ocr.increase.units - 1)}</strong>{" "}
                      {t(($) => $.programs.templateForms["or more"])}
                    </span>
                  </th>
                  <th className="text-center" style={{ color: "#000" }}>
                    <span className="fs-standard">
                      {t(($) => $.programs.templateForms["CR"])} <FaMinusCircle /> <br />
                      <BetweenCR uiState={uiState} />
                    </span>
                  </th>
                  <th className="text-center" style={{ color: "#000" }}>
                    <span className="fs-standard">
                      {t(($) => $.programs.templateForms["CR"])} <FaArrowAltCircleDown /> <br />
                      <strong>{formatPercent(uiState.ocr.lower.units - 1)}</strong>{" "}
                      {t(($) => $.programs.templateForms["or more"])}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center text-uppercase">
                    <span className="fs-standard">
                      {t(($) => $.programs.templateForms["Units"])} <FaArrowAltCircleUp /> <br />
                      <strong>{uiState.units.increase.units}</strong> {t(($) => $.programs.templateForms["or more"])}
                    </span>
                  </td>
                  <td className="text-center">
                    {" "}
                    {t(($) => $.programs.templateForms["Price Up by {percent}"], {
                      percent: formatPercent(uiState.units.increase.percent / 100, { decimalPlaces: 0 }),
                    })}
                  </td>
                  <td className="text-center">
                    {t(($) => $.programs.templateForms["Price Up by {percent}"], {
                      percent: formatPercent(uiState.units.increase.percent / 100, { decimalPlaces: 0 }),
                    })}
                  </td>
                  <td className="text-center">{t(($) => $.programs.templateForms["No Change"])}</td>
                </tr>
                <tr>
                  <td className="text-center text-uppercase">
                    <span className="fs-standard">
                      {t(($) => $.programs.templateForms["Units"])} <FaMinusCircle /> <br />
                      <BetweenUnits uiState={uiState} />
                    </span>
                  </td>
                  <td className="text-center">
                    {t(($) => $.programs.templateForms["Price Up by {percent}"], {
                      percent: formatPercent(uiState.units.increase.percent / 100, { decimalPlaces: 0 }),
                    })}
                  </td>
                  <td className="text-center">{t(($) => $.programs.templateForms["No Change"])}</td>
                  <td className="text-center">
                    {t(($) => $.programs.templateForms["Price Down by {percent}"], {
                      percent: formatPercent(uiState.units.lower.percent / 100, { decimalPlaces: 0 }),
                    })}
                  </td>
                </tr>
                <tr>
                  <td className="text-center text-uppercase">
                    <span className="fs-standard">
                      {t(($) => $.programs.templateForms["Units"])} <FaArrowAltCircleDown /> <br />
                      <strong>{uiState.units.lower.units}</strong> {t(($) => $.programs.templateForms["or less"])}
                    </span>
                  </td>
                  <td className="text-center">{t(($) => $.programs.templateForms["No Change"])}</td>
                  <td className="text-center">
                    {t(($) => $.programs.templateForms["Price Down by {percent}"], {
                      percent: formatPercent(uiState.units.lower.percent / 100, { decimalPlaces: 0 }),
                    })}
                  </td>
                  <td className="text-center">
                    {t(($) => $.programs.templateForms["Price Down by {percent}"], {
                      percent: formatPercent(uiState.units.lower.percent / 100, { decimalPlaces: 0 }),
                    })}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export { MarginCRProfilingForm };
